var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreezingRainLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "freezing_x5F_rain_x5F_light",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5DEE8",
    d: "M11.753,9.5257c-0.064,0-0.129-0.012-0.192-0.0381 c-0.255-0.1059-0.376-0.399-0.27-0.6529l0.478-1.155c0.106-0.256,0.401-0.375,0.654-0.2711c0.255,0.1061,0.376,0.399,0.27,0.654 l-0.478,1.1541C12.135,9.4096,11.949,9.5257,11.753,9.5257 M4.743,9.2167l0.479-1.155c0.105-0.255-0.016-0.5481-0.271-0.6531 c-0.253-0.1059-0.547,0.015-0.653,0.27L3.819,8.8347C3.714,9.0897,3.835,9.3817,4.09,9.4876c0.062,0.0261,0.127,0.0381,0.191,0.0381 C4.477,9.5257,4.663,9.4096,4.743,9.2167 M19.686,9.2167l0.479-1.1541c0.105-0.255-0.016-0.5479-0.271-0.654 c-0.253-0.1039-0.547,0.015-0.653,0.2711l-0.478,1.155c-0.106,0.2539,0.015,0.5471,0.27,0.6529 c0.063,0.0261,0.128,0.0381,0.191,0.0381C19.42,9.5257,19.607,9.4096,19.686,9.2167 M8.479,9.2167l0.478-1.1541 c0.106-0.255-0.015-0.5479-0.27-0.654C8.434,7.3047,8.14,7.4236,8.034,7.6797l-0.479,1.155C7.45,9.0886,7.571,9.3817,7.826,9.4876 c0.062,0.0261,0.127,0.0381,0.191,0.0381C8.213,9.5257,8.399,9.4096,8.479,9.2167 M15.951,9.2167l0.478-1.1541 c0.106-0.255-0.016-0.5479-0.27-0.654c-0.253-0.1039-0.548,0.015-0.654,0.2711l-0.478,1.155c-0.106,0.2539,0.015,0.5471,0.27,0.6529 c0.063,0.0261,0.128,0.0381,0.192,0.0381C15.684,9.5257,15.871,9.4096,15.951,9.2167"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0072F5",
    d: "M21.0001,11.9998h-18c-0.552,0-1,1.0001-1,1.0001 s0.217,0.7189,0.535,0.8859c0.302,0.159,0.465,0.5,0.465,0.842v4.272c0,0.553,1,1,1,1s1-0.447,1-1v-4c0-0.552,1-1,1-1s1,0.448,1,1v2 c0,0.553,1,1,1,1s1-0.447,1-1v-2c0-0.552,1-1,1-1s1,0.448,1,1v2c0,0.553,1,1,1,1s1-0.447,1-1v-2c0-0.552,1-1,1-1s1,0.448,1,1v2 c0,0.553,1,1,1,1s1-0.447,1-1v-2c0-0.552,1-1,1-1s1,0.448,1,1v4c0,0.553,1,1,1,1s1-0.447,1-1v-4.272 c0-0.342,0.162-0.683,0.465-0.842c0.318-0.1669,0.535-0.8859,0.535-0.8859S21.5521,11.9998,21.0001,11.9998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezingRainLight);
export default __webpack_public_path__ + "static/media/freezing_rain_light.994c81a3c01bf0f262ddf7edc7eb2843.svg";
export { ForwardRef as ReactComponent };